// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';

// Ngrx
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { PatientInsuranceModel } from '../_models/patient-insurance.model';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PatientInsuranceService {
  private authToken;
  private companyId: any;
  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  findPatientInsurance(queryParams: QueryParamsModel, id: number): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    let sort = queryParams.sortField.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());
    sort === 'affiliationTypeName' ? (sort = 'affiliationType') : sort;
    const url =
      environment.CORE_BASE +
      `/companies/${this.companyId}/patients/${id}/insurance?page=${queryParams.pageNumber}&size=${queryParams.pageSize}` +
      '&sort=' +
      sort +
      `,${queryParams.sortOrder}`;
    return this.http.get<QueryResultsModel>(url, { headers: httpHeaders });
  }

  getTenantInsurances(): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = environment.CORE_BASE + `/companies/${this.companyId}/insurance?page=0&size=100`;
    return this.http.get<QueryResultsModel>(url, { headers: httpHeaders });
  }

  // DELETE => delete the patient from the server
  deletePatientInsurance(patientInsuranceId: number): Observable<any> {
    const url =
      environment.CORE_BASE +
      `/companies/${this.companyId}/patients/insurance/${patientInsuranceId}`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers: httpHeaders });
  }
  createPatientInsurance(patientInsurance: any | PatientInsuranceModel, patientId: number | any) {
    // Note: Add headers if needed (tokens/bearer)
    const url =
      environment.CORE_BASE + `/companies/${this.companyId}/patients/${patientId}/insurance`;
    const body = patientInsurance;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<PatientInsuranceModel>(url, body, { headers: httpHeaders });
  }

  updatePatientInsurance(patientInsurance: PatientInsuranceModel | any) {
    // Note: Add headers if needed (tokens/bearer)
    const url =
      environment.CORE_BASE +
      `/companies/${this.companyId}/patients/insurance/${patientInsurance.id}`;
    const body = patientInsurance;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<PatientInsuranceModel>(url, body, { headers: httpHeaders });
  }
}
